import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setFormSuccessSubmit } from '../../modules/actions/forms'

export default function useContinuousForm({ initialItemId = null, initialForm, generalFormName }) {
  const dispatch = useDispatch()
  // ContinuousForm allow to have multiple forms in row dependent on each other
  const [itemId, setItemId] = useState(initialItemId)
  const [activatedForm, setActivatedForm] = useState(initialForm)
  // CampaignGoogleCreate consists from several forms
  const [successSubmit, setSuccessSubmit] = useState(false)

  const handleResetForm = useCallback(() => {
    setItemId(initialItemId)
    setActivatedForm(initialForm)
    setSuccessSubmit(false)
  }, [initialItemId, initialForm])

  useEffect(() => {
    if (successSubmit && generalFormName) {
      dispatch(setFormSuccessSubmit(generalFormName))
    }
  }, [dispatch, successSubmit, generalFormName])

  return useMemo(
    () => ({
      activatedForm,
      setActivatedForm,
      itemId,
      setItemId,
      handleResetForm,
      successSubmit,
      setSuccessSubmit
    }),
    [handleResetForm, itemId, activatedForm, successSubmit, setSuccessSubmit]
  )
}
